

import {
  CHANGE_PAGE,
  LOAD_WORD_VERBATIMS_ERROR, LOAD_WORD_VERBATIMS_REQUEST, LOAD_WORD_VERBATIMS_SUCCESS, RADIO_SELECT, RESET_RADIO,
  SET_WORD
} from "./word-verbatims-action-types";

const initialState = {
  word: "",
  loading: false,
  general: {},
  negation: {},
  error: "",
  radio: ["General", "Negation"],
  selectedRadio: "General",
  whoMounted: null,
  generalPage: 1,
  negationPage: 1
};

export default ( state = initialState, action ) => {
  const { word, error, general, negation, selectedRadio, page, previous, next } = action;

  switch(action.type) {

    case RESET_RADIO:
      return {
        ...state,
        selectedRadio: "General"
      };

    case CHANGE_PAGE:
      let whichPage = general ? 'generalPage' : 'negationPage';
      let totalPages;
      general ?
        totalPages = Object.keys(state.general).length
        :
        totalPages = Object.keys(state.negation).length;
      let newPage;
      next ?
        page < totalPages ?
          newPage = page + 1
          :
          null
        :
        page > 1 ?
          newPage = page - 1
          :
          null;

      if (newPage) {
        return {
          ...state,
          [whichPage]: newPage
        };
      }
      return state;


    case RADIO_SELECT:
      return {
        ...state,
        selectedRadio
      };

    case LOAD_WORD_VERBATIMS_SUCCESS:
      return {
        ...state,
        general,
        negation,
        generalPage: 1,
        negationPage: 1,
        error: "",
        loading: false
      };

    case LOAD_WORD_VERBATIMS_ERROR:
      return {
        ...state,
        loading: false,
        error
      };

    case LOAD_WORD_VERBATIMS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
        whoMounted: word
      };

    case SET_WORD:
      return {
        ...state,
        word
      };

    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/word-verbatims/word-verbatims-reducer.js